const MainActionTypes = {
  SET_SELECTED_CATEGORY: "SET_SELECTED_CATEGORY",
  SET_SELECTED_ROUTE: "SET_SELECTED_ROUTE",
  SET_SELECTED_ITEM: "SET_SELECTED_ITEM",
  SET_OPEN_CAMERA_MODULE: "SET_OPEN_CAMERA_MODULE",
};

export default MainActionTypes;
